const isBlankFreeRentValue = value => value == null || value === '';

const isFreeRentSelected = value => value === true || String(value).toLowerCase() === 'true';

const convertFreeRentMonthsToYearsAndMonths = (totalMonths) => {
  if (isBlankFreeRentValue(totalMonths)) return { years: '', months: '' };
  const numericMonths = Number(totalMonths);
  if (Number.isNaN(numericMonths)) return { years: '', months: '' };
  return {
    years: Math.floor(numericMonths / 12),
    months: numericMonths % 12,
  };
};

const getFreeRentTotalMonths = (yearsValue, monthsValue) => {
  if (isBlankFreeRentValue(yearsValue) && isBlankFreeRentValue(monthsValue)) return null;
  const years = isBlankFreeRentValue(yearsValue) ? 0 : parseInt(yearsValue, 10);
  const months = isBlankFreeRentValue(monthsValue) ? 0 : parseFloat(monthsValue);
  return (years * 12) + months;
};

const getUpdatedFreeRentTotalMonths = ({ currentTotalMonths, part, value }) => {
  if (isBlankFreeRentValue(value) && Number(currentTotalMonths) === 0) return null;
  const currentParts = convertFreeRentMonthsToYearsAndMonths(currentTotalMonths);
  return getFreeRentTotalMonths(
    part === 'years' ? value : currentParts.years,
    part === 'months' ? value : currentParts.months,
  );
};

const getFreeRentRequiredError = (value, showPageValidation, fallbackError) => (
  isBlankFreeRentValue(value) && showPageValidation ? 'Free Rent is required' : fallbackError
);

const formatFreeRentYearMonth = (totalMonths) => {
  if (isBlankFreeRentValue(totalMonths)) return null;
  const numericMonths = Number(totalMonths);
  if (Number.isNaN(numericMonths)) return null;
  if (numericMonths === 0) return '0 Years 0 Months';

  const years = Math.floor(numericMonths / 12);
  const months = parseFloat((numericMonths % 12).toFixed(4));
  let yearStr = '';
  let monthStr = '';

  if (years > 0) yearStr = `${years} year`;
  if (years > 1) yearStr = `${years} years`;
  if (months > 0) monthStr = `${months} month`;
  if (months > 1) monthStr = `${months} months`;

  return `${yearStr} ${monthStr}`.trim();
};

export {
  convertFreeRentMonthsToYearsAndMonths,
  formatFreeRentYearMonth,
  getFreeRentRequiredError,
  getFreeRentTotalMonths,
  getUpdatedFreeRentTotalMonths,
  isBlankFreeRentValue,
  isFreeRentSelected,
};
